import { createConsumer } from "@rails/actioncable"

(function () {
  globalThis.App = globalThis.App || {};
  globalThis.App.cable = createConsumer();
}).call(this);

export default createConsumer()
